import { render, staticRenderFns } from "./GeneralAdjustmentStockTable.vue?vue&type=template&id=bbf1c81a"
import script from "./GeneralAdjustmentStockTable.vue?vue&type=script&lang=js"
export * from "./GeneralAdjustmentStockTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports